import * as React from 'react';

import { useAppSelector } from 'app';
import { selectAppDevice } from 'slice';
import { DEVICES } from 'utils/constants';

import AccountDesktop from './AccountDesktop';
import AccountMobile from './AccountMobile';

interface AccountCardProps {
  item: any;
  onSelected: any;
  itemList?: any[];
  handleChangeAccountList?: (e: any[]) => void;
}

// 0: 'user', 1: 'farm', 2: 'store', 3: 'collaborator', 4: 'warehouse', 5: 'transport', 6: 'volunteer'
const AccountCard = ({
  item,
  onSelected,
  itemList,
  handleChangeAccountList,
}: AccountCardProps): JSX.Element => {
  const appDevice = useAppSelector(selectAppDevice);

  const renderElements = {
    [DEVICES.DESKTOP]: (
      <AccountDesktop
        handleChangeAccountList={handleChangeAccountList}
        item={item}
        itemList={itemList}
        onSelected={onSelected}
      />
    ),
    [DEVICES.MOBILE]: <AccountMobile item={item} onSelected={onSelected} />,
    [DEVICES.TABLET]: <AccountMobile item={item} onSelected={onSelected} />,
  };

  return renderElements[appDevice.device];
};

export default AccountCard;
